var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b({ active: _vm.active }),on:{"click":_vm.onClick}},[_c('span',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title)+" ")]),_c('span',{class:_vm.b('content')},[_vm._v(_vm._s(_vm.content)+" ")]),(_vm.active)?_c('v-btn',{attrs:{"small":"","icon":"","color":"primary"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }